import { useEffect, useRef, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
import account from '../../../_mock/account';
import { useNavigate } from 'react-router-dom';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify/Iconify';
import ProfileModal from 'src/components/modal/Profile';
import ChangePassModal from 'src/components/modal/ChangePassModal';
import crypt from 'src/utils/service/crypt';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmDeviceModal';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
    {
        label: 'Thông tin tài khoản',
        icon: 'eva:person-fill',
    },
    {
        label: 'Đổi mật khẩu',
        icon: 'material-symbols:lock-reset',
    },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
    const [open, setOpen] = useState(null);
    const [visible, setVisible] = useState(false);
    const [user, setUser] = useState({});
    const [visibleConfirm, setVisibleConfirm] = useState(false);

    const [visibleChange, setVisibleChange] = useState(false);
    const { t } = useTranslation();
    const [flagGetStat, setFlagGetStat] = useState(false);
    const navigate = useNavigate();
    // const user = JSON.parse(Crypt.deCode(sessionStorage.getItem('proc_data')))
    const logoutFlag = useRef(false);
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };
    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');
        if (!userData || !menu) {
            navigate('/login');
        }
        if (userData && menu) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                glb_sv.userInfo = data;
                setUser(data);
                glb_sv.menu = JSON.parse(crypt.deCode(menu));
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;
            } catch (error) {}
        }
    }, []);
    const handleClose = () => {
        setOpen(null);
    };

    const handleLogout = () => {
        if (logoutFlag.current === true) return;
        logoutFlag.current = true;
        setFlagGetStat(true);
        let InVal = [];
        sendRequest(serviceList.logout, InVal, logoutResult, true, timeOutFunct, 40000);
    };

    const logoutResult = (reqInfoMap, message) => {
        logoutFlag.current = false;
        setFlagGetStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            const cabinet_cd = glb_sv.getLocalStorageCabinet('cabinet');
            console.log('cabinet_cd', cabinet_cd);

            logoutIOT(cabinet_cd?.cabinet_cd || '');
            sessionStorage.removeItem('proc_data');
            sessionStorage.removeItem('menu');

            sessionStorage.removeItem('cabinet');
            sessionStorage.removeItem('cabinetCode');
            sessionStorage.removeItem('category');
            glb_sv.authFlag = false;
            navigate('/login');
        }
    };

    const timeOutFunct = (reqInfo) => {
        logoutFlag.current = false;
        setFlagGetStat(false);
        toast.error(t('error.time_out'));
    };
    // region CALL API login IOT

    const logoutIOT = (cabinet_cd) => {
        sendRequest(serviceList.logoutIOT, [cabinet_cd], logoutIOTResult, true, timeOutFunctIOT, 40000, 0);
    };
    const logoutIOTResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            toast.success('Error: ' + message['proc_message']);
        }
    };
    const timeOutFunctIOT = (e) => {
        toast.error(t('error.time_out') + ' IOT');
    };
    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
                        },
                    }),
                }}
            >
                <Avatar color="primary" />
            </IconButton>
            <ChangePassModal visible={visibleChange} setVisible={setVisibleChange} />
            <ConfirmModal visible={visibleConfirm} handleConfirm={handleLogout} setVisible={setVisibleConfirm} />
            <ProfileModal dataUpdate={user} visible={visible} setVisible={setVisible} />
            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 0,
                        mt: 1.5,
                        ml: 0.75,
                        width: 220,
                        '& .MuiMenuItem-root': {
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <Loader loading={flagGetStat} />
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {user?.user_nm ? user.user_nm : '--/--'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {user?.email ? user.email : '--/--'}
                    </Typography>
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Stack sx={{ p: 1 }}>
                    <MenuItem onClick={() => setVisible(true)} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', paddingRight: 0.3 }} noWrap>
                            <Iconify icon={'eva:person-fill'} width={20} height={20} />
                        </Typography>
                        {t('info_account')}
                    </MenuItem>
                    <MenuItem onClick={() => setVisibleChange(true)} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', paddingRight: 0.3 }} noWrap>
                            <Iconify icon={'material-symbols:lock-reset'} width={20} height={20} />
                        </Typography>
                        {t('change_password')}
                    </MenuItem>
                </Stack>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <MenuItem onClick={() => setVisibleConfirm(true)} sx={{ m: 1 }}>
                    <Iconify icon={'material-symbols:logout-sharp'} width={20} height={20} />
                    {t('logout')}
                </MenuItem>
            </Popover>
        </>
    );
}
